import Vue from 'vue'

Vue.config.productionTip = false



// WEBPACK FOOTER //
// ./src/front/init/common.js